module.exports = __webpack_public_path__ + "static/fonts/Montserrat800italic.9b9e2f46.ttf";